import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/InvoiceOutReport/APReportInvoiceAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class APReportInvoiceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/InvoiceOutReport/APReportInvoice")
	}

	render() {
		return (
			<Activity 
				name="APReportInvoice"
				RenderedComponent={this.RenderedComponent}
				context="APReportInvoice"
				action="APReportInvoice"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(APReportInvoiceActivity)
